/* Contador de promocao. Le a data REAL de fim (settings.promo_fim); zerou, esconde o bloco. */
(function () {
  var els = document.querySelectorAll('.hub-countdown');
  if (!els.length) return;
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var now = Date.now();
    els.forEach(function (el) {
      var fim = Date.parse(el.getAttribute('data-fim'));
      var d = fim - now;
      if (isNaN(d) || d <= 0) { var box = el.closest('.hub-promo'); if (box) box.hidden = true; return; }
      var s = Math.floor(d / 1000), dias = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var u = (el.getAttribute('data-u') || 'd|h|m|s').split('|');  // unidades no idioma da pagina (hub.promo.unidades)
      el.textContent = (dias ? dias + u[0] + ' ' : '') + pad(h) + u[1] + ' ' + pad(m) + u[2] + (dias ? '' : ' ' + pad(sec) + u[3]);
    });
  }
  tick(); setInterval(tick, 1000);
})();
